/**
 * Tela "desligada" de um slot de evento screen_off (F-24, revisão 2026-10-26): preto puro pela duração do
 * item, sem conteúdo e sem proof-of-play. O loop reavalia a agenda ao fim de cada item, então a tela volta
 * ao conteúdo assim que a janela do slot (ou o trigger) deixar de valer.
 */
import { useEffect } from 'react'
import type { PlaybackResult } from '@/types/player.types'

interface Props {
  durationSeconds: number
  onEnd: (result: PlaybackResult) => void
}

export function ScreenOffRenderer({ durationSeconds, onEnd }: Props) {
  useEffect(() => {
    const timer = setTimeout(() => onEnd({ played: false }), durationSeconds * 1000)
    return () => clearTimeout(timer)
  }, [durationSeconds, onEnd])

  return <div data-testid="screen-off" style={{ position: 'absolute', inset: 0, background: '#000' }} />
}
